<template>
  <span>
    <span @click="dialogVisible = true">
      <slot />
    </span>
    <el-dialog title="Edit Inventory" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="SKU" prop="sku">
          <el-input v-model="form.sku"></el-input>
        </el-form-item>
        <el-row :gutter="15">
          <el-col :xs="24" :sm="12">
            <el-form-item label="Price" prop="price">
              <el-input v-model="form.price" class="input-select">
                <el-select v-model="form.currency" slot="append" placeholder="Select currency">
                  <el-option label="MYR" value="MYR"></el-option>
                  <el-option label="SGD" value="SGD"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Available stock" prop="stockAvailable">
              <el-input v-model="form.stockAvailable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :xs="24" :sm="8">
            <el-form-item label="Discount begin" prop="discountPrice">
              <el-date-picker v-model="form.discountBegin" type="date"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="Discount end" prop="discountPrice">
              <el-date-picker v-model="form.discountEnd" type="date"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="Discount price" prop="discountPrice">
              <el-input-number v-model="form.discountPrice" :precision="2" :step="1"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
        <el-button @click="onCancel('form')">Cancel</el-button>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: {
    inventory: Object,
  },

  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        currency: this.inventory.currency,
        discountBegin: this.inventory.discount ? this.inventory.discount.begin : null,
        discountEnd: this.inventory.discount ? this.inventory.discount.end : null,
        discountPrice: this.inventory.discount ? this.inventory.discount.price : null,
        price: this.inventory.price,
        sku: this.inventory.sku,
        stockAvailable: this.inventory.stock.available,
      },
      rules: {
        'price': [
          { required: true, message: 'Enter a product price.', trigger: 'blur' },
        ],
        'sku': [
          { required: true, message: 'Enter the product identifier.', trigger: 'blur' },
        ],
        'stockAvailable': [
          { required: true, message: 'Enter the available stock.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.put(`/inventories/${ this.inventory.id }`, {
            currency: this.form.currency,
            discount_begin: this.form.discountBegin,
            discount_end: this.form.discountEnd,
            discount_price: this.form.discountPrice,
            price: this.form.price,
            sku: this.form.sku,
            stock_available: this.form.stockAvailable,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.dialogVisible = false
        this.$emit('update')
        this.$message.success(data.message)
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style>
.input-select .el-input-group__append {
  width: 100px;
  padding: 0;
}

.input-select .el-select {
  margin: -10px 0;
  text-align: right;
}
</style>
